import { useQuery } from '@tanstack/react-query';
import type { GetPrescriptionsForPatientParams } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPrescriptionsForPatient } from '../api/getPrescriptionsForPatient.js';
import { rxKeys } from './keys.js';

const DEFAULT_PRESCRIPTIONS_PARAMS: GetPrescriptionsForPatientParams = { synchronize: true };

function normalizePrescriptionsParams(
  params?: GetPrescriptionsForPatientParams
): GetPrescriptionsForPatientParams {
  return {
    ...DEFAULT_PRESCRIPTIONS_PARAMS,
    ...(params ?? {}),
  };
}

export function patientPrescriptionsQueryDefinition(
  userId: string,
  params?: GetPrescriptionsForPatientParams
) {
  const normalizedParams = normalizePrescriptionsParams(params);

  return {
    queryKey: rxKeys.patientPrescriptions(userId, normalizedParams),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPrescriptionsForPatient(userId, normalizedParams, signal),
    meta: {
      toast: {
        title: 'Could not load patient prescriptions',
        description: 'Patient prescriptions could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePatientPrescriptionsQuery(
  userId: string | undefined,
  params?: GetPrescriptionsForPatientParams
) {
  return useQuery({
    ...patientPrescriptionsQueryDefinition(userId ?? '', params),
    enabled: !!userId,
  });
}
